import { memo } from 'react'

import { ConfirmationDialog } from '@collaborate-health/uikit'
import { sessionTitleFormatter, trainingMaterialTitleFormatter } from '@tabeeb/shared/utils/text'

export interface TrainingMaterialDeleteConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

const TrainingMaterialDeleteConfirmationDialog: React.FC<TrainingMaterialDeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title={trainingMaterialTitleFormatter.format('Are you sure you want to delete training material?')}
      dialogMessage={`Deleting this ${trainingMaterialTitleFormatter.format(
        'training material'
      )} will permanently remove it and detach it from all associated ${sessionTitleFormatter.format('sessions')}`}
      submitButtonColor='error'
      submitButtonText='Delete'
    />
  )
}

export default memo(TrainingMaterialDeleteConfirmationDialog)

